import { useContext } from "react";
import { Language } from "../../App";

export const GetNotificationBody = ({ type, notificationType, fallbackBody, isSingle = true }) => {
    const { lang } = useContext(Language);
    const messages = {
      social: {
        follow: lang?.started_following_you || "started following you",
        comment: lang?.commented_on_your_post || "commented on your post",
        like: lang?.liked_your_post || "liked your post",
        repost: lang?.reposted_your_post || "reposted your post",
      },
      webinar: {
        reserve: lang?.reserved_your_webinar || "reserved your webinar",
        invite: (single) =>
          single ? (lang?.invited_you_to_his_webinar || "invited you to his webinar") : (lang?.invited_you_to_their_webinar || "invited you to their webinar"),
        host: (single) =>
          single ? (lang?.has_made_you_host_in_his_webinar || "has made you host in his webinar") : (lang?.has_made_you_host_in_their_webinar || lang?.has_made_you_host_in_his_webinar || "has made you host in their webinar"),
        start: lang?.your_webinar_has_been_started || "your webinar has been started",
      },
      clinical: {
        reserve: lang?.reserved_your_clinical_study || "reserved your clinical study",
        comment: lang?.commented_on_your_clinical_study_post || "commented on your clinical study post",
        like: lang?.liked_your_clinical_study_post || "liked your clinical study post",
        repost: lang?.reposted_your_clinical_study_post || "reposted your clinical study post",
      },
      course: {
        purchase: lang?.purchased_your_course || "purchased your course",
      },
      event:{
        join: lang?.joined_event || "joined event",
        start: lang?.event_has_been_started || "event has been started",
      },
      "clinical-session": {
        invite: lang?.invited_you_to_his_clinical_session || "invited you to his clinical session",
        started: lang?.clinical_session_has_been_started || "clinical session has been started",
        start: lang?.clinical_session_has_been_started || "clinical session has been started",
      },
      wallet: {
        payment: lang?.made_a_payment_to_your_wallet || "made a payment to your wallet",
        refund: lang?.received_a_refund_in_your_wallet || "received a refund in your wallet",
      },
      // Consultation tab notifications (type: "mentor") get their own card —
      // NotificationCardMentor in Notification.jsx — instead of going through
      // this generic like/follow body, so there's no entry for it here.
    };
  
    const typeMessages = messages[type];
    if (!typeMessages) return (fallbackBody || "").trim();
  
    const message = typeMessages[notificationType];
    if (!message) return (fallbackBody || "").trim();
  
    // Handle dynamic messages (like "invite" or "host" in webinars)
    const result = typeof message === "function" ? message(isSingle) : message;
    return result || (fallbackBody || "").trim();
  };
  
  